import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceGroup } from '@quorum/models/xs-resource';

export interface PendingAcceptedServicesState extends EntityState<ServiceGroup> {}

export const pendingAcceptedServicesAdapter: EntityAdapter<ServiceGroup> = createEntityAdapter<ServiceGroup>({
  selectId: (serviceGroup: ServiceGroup) => serviceGroup.id
});

export const initialState: PendingAcceptedServicesState = pendingAcceptedServicesAdapter.getInitialState({});
export const PendingAcceptedServicesFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const pendingAcceptedServiceSelector = createSelector(
  PendingAcceptedServicesFeatureSelector,
  (state: any) => state.pendingAcceptedServices
);
export const { selectIds, selectEntities, selectAll, selectTotal } = pendingAcceptedServicesAdapter.getSelectors(
  pendingAcceptedServiceSelector
);
